/**
 * Il tema dei colori, uno per persona.
 *
 * La scelta sta nel browser di chi la fa: non e' un dato dell'azienda, e due
 * persone sullo stesso gestionale possono vederlo in due modi diversi. Il
 * foglio di stile che fa il lavoro e' `temi.css`; qui si decide soltanto
 * quale attributo mettere sulla pagina, e ci si ricorda la scelta.
 */
export const TEMI = [
  { codice: "", nome: "Chiaro", nota: "Come è sempre stato", campione: ["#f8fafc", "#ffffff", "#0067b2"] },
  { codice: "scuro", nome: "Scuro", nota: "Riposa gli occhi la sera", campione: ["#10151d", "#171f2a", "#2196f3"] },
  { codice: "blu", nome: "Blu notte", nota: "Scuro, sui blu di SGM", campione: ["#0b1622", "#122132", "#38bdf8"] },
  { codice: "sole", nome: "Sole forte", nota: "Per leggere in cantiere", campione: ["#ffffff", "#e2e8f0", "#00497f"] },
];

const CHIAVE = "sgm-tema";

export function temaSalvato() {
  try {
    const scelto = window.localStorage.getItem(CHIAVE) || "";
    return TEMI.some((t) => t.codice === scelto) ? scelto : "";
  } catch {
    return "";
  }
}

export function applicaTema(codice) {
  const radice = document.documentElement;
  if (codice) radice.setAttribute("data-tema", codice);
  else radice.removeAttribute("data-tema");
  try {
    if (codice) window.localStorage.setItem(CHIAVE, codice);
    else window.localStorage.removeItem(CHIAVE);
  } catch {
    /* navigazione in incognito: il tema vale per questa sessione e basta */
  }
}

/** Si chiama una volta sola all'avvio, prima di disegnare. */
export function avviaTema() {
  applicaTema(temaSalvato());
}
